import { OptionsModal } from "./OptionsModal";
import { AlertModal } from "./AlertModal";
import { RedeemPointsModal } from "./RedeemPointsModal";

export const ModalTemplate = {
  Options: OptionsModal,
  Alert: AlertModal,
  RedeemPoints: RedeemPointsModal
};
